import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryRearing = () => {
  return <CategoryBase baseEndpoint="category_rearing" />;
};

export default CategoryRearing;
